var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_start mb-12",staticStyle:{"height":"56px"}},[_c('div',{staticClass:"num-title"},[_c('img',{attrs:{"src":require("../../assets/image/title_bg.png"),"alt":""}}),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.num))])]),_c('div',{staticClass:"num-title-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }